function initMobileNavigationTest(value){
    if(value === '1'){
        console.log('Experiment Running: Mobile Navigation Redesign');
        const items = document.querySelectorAll('.link-item-with-background');
        items.forEach(item => item.classList.add('variant-b'));
    }
}

gtag('event', 'optimize.callback', {
    name: 'I0iMihhKQO2A6JVqCNrOzQ',
    callback: initMobileNavigationTest
 });